import { registerMockAPI } from '~/mocks/mockApis';

import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetInboundRequestProgressParams } from '~/types/receive.types';

type TypeGetInboundRequestProgressDownloadMutationParams = TypeGetInboundRequestProgressParams & {
  ownerCode: string;
};

const fetchInboundRequestProgressDownload = async ({
  ownerCode,
  ...params
}: TypeGetInboundRequestProgressDownloadMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_INBOUND_REQUEST_PROGRESS_DOWNLOAD}/${ownerCode}/inbound-request/progress/download`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고현황] 3PL 입고현황 엑셀 다운로드 Mutation Hook
 */
export const useGetInboundRequestProgressDownloadMutation = () => {
  return useDownloadMutation(fetchInboundRequestProgressDownload);
};

registerMockAPI<null>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/inbound-request/progress/download',
  label: '입고/입고현황3PL/목록다운로드',
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '3PL 입고현황 목록 다운로드 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
